/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ShareClaimAccessResponse } from './ShareClaimAccessResponse';
import {
    instanceOfShareClaimAccessResponse,
    ShareClaimAccessResponseFromJSON,
    ShareClaimAccessResponseFromJSONTyped,
    ShareClaimAccessResponseToJSON,
} from './ShareClaimAccessResponse';
import type { ShareClaimPendingInviteResponse } from './ShareClaimPendingInviteResponse';
import {
    instanceOfShareClaimPendingInviteResponse,
    ShareClaimPendingInviteResponseFromJSON,
    ShareClaimPendingInviteResponseFromJSONTyped,
    ShareClaimPendingInviteResponseToJSON,
} from './ShareClaimPendingInviteResponse';

/**
 * @type ShareClaimResponse
 * Result of POST /claims/{claimId}/shares. Discriminated by `kind`: `access` when the email matched an existing user/company and an access grant was created immediately; `pending` when the email had no account yet and an email invitation to create one was sent instead. Clients should switch on `kind`.
 * @export
 */
export type ShareClaimResponse = { kind: 'access' } & ShareClaimAccessResponse | { kind: 'pending' } & ShareClaimPendingInviteResponse;

export function ShareClaimResponseFromJSON(json: any): ShareClaimResponse {
    return ShareClaimResponseFromJSONTyped(json, false);
}

export function ShareClaimResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimResponse {
    if (json == null) {
        return json;
    }
    switch (json['kind']) {
        case 'access':
            return Object.assign({}, ShareClaimAccessResponseFromJSONTyped(json, true), { kind: 'access' } as const);
        case 'pending':
            return Object.assign({}, ShareClaimPendingInviteResponseFromJSONTyped(json, true), { kind: 'pending' } as const);
        default:
            throw new Error(`No variant of ShareClaimResponse exists with 'kind=${json['kind']}'`);
    }
}

export function ShareClaimResponseToJSON(json: any): any {
    return ShareClaimResponseToJSONTyped(json, false);
}

export function ShareClaimResponseToJSONTyped(value?: ShareClaimResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    switch (value['kind']) {
        case 'access':
            return Object.assign({}, ShareClaimAccessResponseToJSON(value), { kind: 'access' } as const);
        case 'pending':
            return Object.assign({}, ShareClaimPendingInviteResponseToJSON(value), { kind: 'pending' } as const);
        default:
            throw new Error(`No variant of ShareClaimResponse exists with 'kind=${value['kind']}'`);
    }

}

